import axios from '@/lib/axios';
import { PaymentTaskComment, PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1120. 支払タスクコメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};
const createPaymentTaskComment = (props: Props): Promise<PaymentTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_comments`,
    props
  );
};

export const useCreatePaymentTaskComment = () => {
  return useMutation({
    mutationFn: createPaymentTaskComment,
  });
};
